export default class ScrollupSticky{

    constructor(element) {
        this.$element  = $(element);
        this.$window = $(window);
        this.lastScrollTop = 0;
        this.threshold = 2;
    }

    init() {
        this.setListeners();
    }

    setListeners() {
        this.$window.off('scroll.scrollupsticky').on('scroll.scrollupsticky', this.scrollup.bind(this));
    }

    scrollup() {
        const st = this.$window.scrollTop();
        if (st > this.lastScrollTop + this.threshold) { //going down
            var cur = this.$element.get(0).getBoundingClientRect().y;
            if(cur >= -1 && cur < 20) {
                this.$element.addClass('slide-hidden');
            }
        } else if (st < this.lastScrollTop - this.threshold) {
            this.$element.removeClass('slide-hidden');
            this.$element.addClass('sticky-border-bottom');

            if(this.$element.get(0).getBoundingClientRect().y > 0) {
                this.$element.removeClass('sticky-border-bottom');
            }
        }
        this.lastScrollTop = st;
    }
}
